module.exports = __webpack_public_path__ + "static/img/logo_16.a0fd9ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/logo_16.png
// module id = DsCM
// module chunks = 1